import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">专题索引</h2>
          <p className="mt-2 text-sm text-foreground-600">按分类快速浏览你感兴趣的爆料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-1.5">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-[10px] font-semibold text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
                  {item.count}篇
                </span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexData.slice(4).map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-1.5">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-[10px] font-semibold text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
                  {item.count}篇
                </span>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}